import { createContext } from 'react'
import { ToastType } from '@app/components/blocks/toast/Toast'

export type ToastModel = {
  id: string
  message: string
  type: ToastType
  hideAfterSeconds?: number
}

export type ToastContextType = {
  showToast: (
    type: ToastType,
    message: string,
    hideAfterSeconds?: number,
  ) => void
  showSuccessToast: (message: string, hideAfterSeconds?: number) => void
  showFailToast: (message?: string, hideAfterSeconds?: number) => void
}

export const ToastContext = createContext<ToastContextType>({
  showToast: () => {},
  showSuccessToast: () => {},
  showFailToast: () => {},
})
